<template>
	<input
		@change="checkValue(+$event.target.value)"
		:id="name"
		:max="maxVal"
		:min="minVal"
		:name="name"
		:value="inputVal"
		required
		type="number"
	/>
</template>

<script>
import { store, mutations } from "../store";

export default {
	created() {
		switch (this.name) {
			case "quantity":
				this.calculateCostFactor(this.minVal);
				break;

			case "pages":
				this.calculatePageDiscount(this.minVal);
				break;
		}

		this.$emit("input-changed", this.minVal);
	},

	data() {
		return {
			evenOnly: Number(this.data.even_only),
			maxVal: Number(this.data.max),
			minVal: Number(this.data.min),
			inputVal: 0
		};
	},

	methods: {
		calculateCostFactor(qty) {
			let costFactor = this.data.cost_factors.find(
				x => x.min_quantity <= qty && x.max_quantity >= qty
			);
			costFactor = costFactor === undefined ? 0 : costFactor.multiplier;

			mutations.setCostFactor(costFactor);
			mutations.setQty(qty);

			this.inputVal = store.qty;
		},

		calculatePageDiscount(pages) {
			let pageDiscount = this.data.volume_discount.find(
				x => x.min_pages <= pages && x.max_pages >= pages
			);
			pageDiscount =
				pageDiscount === undefined ? 0 : pageDiscount.discount;

			mutations.disableIncompatibleBinding(pages);
			mutations.setPageDiscount(pageDiscount);
			mutations.setPages(pages);

			this.inputVal = store.pages;
		},

		checkValue(val) {
			this.inputVal = val;

			if (this.inputVal < this.minVal) {
				this.inputVal = this.minVal;
			} else if (this.inputVal > this.maxVal) {
				this.inputVal = this.maxVal;
			}

			// if "even_only" flag is set, only allow even values
			if (this.evenOnly) {
				if (this.inputVal % 2 !== 0) {
					this.inputVal = val + 1;
				}
			}

			switch (this.name) {
				case "pages":
					this.calculatePageDiscount(this.inputVal);
					break;

				case "quantity":
					this.calculateCostFactor(this.inputVal);
					break;
			}

			this.$emit("input-changed", this.inputVal);
		}
	},

	props: {
		data: {
			type: Object,
			required: true
		},

		name: {
			type: String,
			required: true
		}
	}
};
</script>
